import React from 'react';
import { get } from 'lodash';
import { Card, CardHeader } from 'common/Card';
import { usePopulate } from 'api/APIHooks';
import PropTypes from 'prop-types';
import { epochToDate } from 'common/utils/utils';
import { FullWidthDetailList } from '../Layout';
import { BaseLineItem } from '../LineItems';
import CaseStatus from '../../../components/CaseStatus';

const CaseDetailsCard = ({ serviceAuthorization }) => {
  const kase = get(serviceAuthorization, 'case', {});
  const caseOpenedDate = epochToDate(kase.opened_date);
  const caseClosedDate = epochToDate(kase.closed_date);
  usePopulate('provider', 'provider', kase, { queryConfig: { placeholderData: undefined } });
  usePopulate('network', 'network', kase, { queryConfig: { placeholderData: undefined } });

  const isCaseLoaded = !!kase?.state && !!kase?.provider && !!kase?.network;

  return (
    <Card className="bg-white" data-testid="referral-details-card">
      <CardHeader
        className="pt-2 pl-2 space-y-2"
        title="Case Details"
      />
      <FullWidthDetailList className="p-6">
        <BaseLineItem
          field="Case Status"
          isLoaded={isCaseLoaded}
          dataTestElement="case-status"
        >
          <CaseStatus
            state={kase.state}
            openedDate={caseOpenedDate}
            closedDate={caseClosedDate}
            showStatusDot={false}
          />
        </BaseLineItem>
        <BaseLineItem
          field="Created at"
          isLoaded={isCaseLoaded}
          dataTestElement="case-created-at"
        >
          {kase.provider.name}
        </BaseLineItem>
        <BaseLineItem
          field="Recipient Network"
          isLoaded={isCaseLoaded}
          dataTestElement="case-network"
        >
          {kase.network.name}
        </BaseLineItem>
      </FullWidthDetailList>
    </Card>
  );
};

CaseDetailsCard.propTypes = {
  serviceAuthorization: PropTypes.object.isRequired,
};

export default CaseDetailsCard;
